export default __webpack_public_path__ + "static/media/external_certifications.fc07b044.png";